module.exports = __webpack_public_path__ + "img/otherSmall.28aceb6f.jpg";